import * as React from "react";
import { useState } from "react";
import { DefaultButton, Link } from "@fluentui/react";
import { strings } from "@src/i18n/strings";
import { friendlyErrorMessage } from "@taskpane/utils/friendlyErrorMessage";
import { colors } from "@taskpane/theme";

const appStrings = strings.components.app;

const messageStyle: React.CSSProperties = {
  margin: 0,
  fontSize: "14px",
  fontWeight: 600,
  color: colors.text,
};
const detailsStyle: React.CSSProperties = {
  margin: 0,
  maxWidth: "100%",
  fontSize: "11px",
  color: colors.textMuted,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
};

export interface ErrorScreenProps {
  error: string;
  onRetry: () => void;
}

export default function ErrorScreen({ error, onRetry }: ErrorScreenProps) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="error-container" role="alert">
      <p style={messageStyle}>{friendlyErrorMessage(error)}</p>
      <DefaultButton text={appStrings.error.tryAgain} onClick={onRetry} />
      <Link onClick={() => setShowDetails((v) => !v)} aria-expanded={showDetails}>
        {showDetails ? appStrings.error.hideDetails : appStrings.error.details}
      </Link>
      {showDetails && <p style={detailsStyle}>{error}</p>}
    </div>
  );
}
